import Layout from "../Layout/Layout.js";
import Home from "../components/Home.js";
import Personal from "../Pages/Projects/Personal.js";
import Webapp from "../Pages/Projects/Webapp.js";
import Eshop from "../Pages/Projects/Eshop.js";
import Contact from "../Pages/Contact";

const routes = [
  {
    path: "/",
    component: Layout,
    exact: false,
    routes: [
      {
        path: "/",
        component: Home,
        exact: true,
      },
      {
        path: "/personal",
        component: Personal,
        exact: true,
      },
      {
        path: "/webapp",
        component: Webapp,
        exact: true,
      },
      {
        path: "/eshop",
        component: Eshop,
        exact: true,
      },
      {
        path: "/contact",
        component: Contact,
        exact: true,
      },
    ],
  },
];

export default routes;
